export default "__VITE_ASSET__w28o$MAi__"